import { CLOUDINARY_ENDPOINT } from '../consts/config';
import { IMAGE_DEFAULTS } from '../consts/image';
import { IDamImage } from '../models/content.interfaces';

export function getCloudinaryUrl(
  image: IDamImage | string,
  width?: number,
  formatAuto: boolean = true,
  quality: number = IMAGE_DEFAULTS.QUALITY,
): string {
  const imageSHA = typeof image === 'object' ? image.sha : image;
  return `${CLOUDINARY_ENDPOINT}/q_${quality}${formatAuto ? ',f_auto' : ''}${
    width ? `,c_scale,w_${width}` : ''
  }/${imageSHA}`;
}
